/** Words for the live parts of the phone apps: job offers and the connection dot. */
export const liveMessages = {
  fr: {
    offer: {
      title: 'Nouvelle collecte',
      description: 'Premier arrivé, premier servi.',
      from: 'À récupérer chez',
      parcels: '{count} colis | {count} colis',
      cash: 'Espèces à encaisser',
      accept: 'Accepter',
      slide: 'Glissez pour accepter',
      later: 'Plus tard',
      more: '{count} autre en attente | {count} autres en attente',
      taken: 'Cette collecte vient d’être prise par un autre livreur.',
      accepted: 'Collecte acceptée',
      toast: 'Nouvelle collecte disponible',
      returnTitle: 'Retour à récupérer',
      returnTo: 'À rapporter à',
      returnAccepted: 'Retour accepté',
      code: 'Code du colis',
      view: 'Voir'
    },
    job: {
      drop: 'Déposer à {relay}',
      dropHint: '{count} colis sur vous | {count} colis sur vous',
      dropMany: '{count} colis, {relays} relais | {count} colis, {relays} relais',
      collect: 'Collecter chez {point}',
      dropNearest: 'Le plus proche de {relays} relais · {km} km | Le plus proche de {relays} relais · {km} km',
      nearestFirst: 'Le plus proche d’abord',
      collectAnon: 'Collecter votre collecte acceptée',
      collectHint: '{count} colis à récupérer | {count} colis à récupérer',
      accept: '{count} collecte à prendre | {count} collectes à prendre',
      acceptHint: 'Premier arrivé, premier servi',
      navigate: 'Itinéraire',
      call: 'Appeler'
    },
    arrivalOffer: {
      title: 'Un livreur est là',
      description: 'Un livreur vient de déposer des colis chez vous. Recevez-les avec lui.',
      from: 'Livreur',
      slide: 'Glissez pour recevoir',
      later: 'Plus tard',
      more: '{count} autre livreur en attente | {count} autres livreurs en attente'
    },
    returnReady: {
      title: 'Votre colis est de retour',
      hint: 'Récupérez-le au relais avec ce code.',
      open: 'Ouvrir mon colis',
      later: 'Plus tard',
      relay: 'Relais'
    },
    returnOffer: {
      badge: 'Retour',
      depositTitle: 'Retour accepté',
      depositDescription: 'Reprenez le colis puis déposez-le pour qu’un livreur le ramène.',
      depositHeadline: 'Reprenez le colis et déposez-le',
      arriveTitle: 'Le livreur est là',
      arriveDescription: 'Un livreur vous ramène un colis retourné. Recevez-le, puis remettez-le à son expéditeur.',
      arriveHeadline: 'Un colis revient chez vous',
      sender: 'Expéditeur',
      recipient: 'Destinataire',
      depositSlide: 'Glissez pour le reprendre',
      arriveSlide: 'Glissez pour le recevoir',
      received: 'Colis reçu',
      handbackTitle: 'Annulation acceptée',
      handbackDescription: 'Le client vient récupérer son colis. Gardez-le au comptoir et demandez-lui son code.',
      handbackHeadline: 'Gardez le colis pour le client',
      handbackSlide: 'Glissez pour ouvrir le colis',
      later: 'Plus tard',
      more: '{count} autre retour en attente | {count} autres retours en attente'
    },
    requestOffer: {
      title: 'Nouvelle demande de dépôt',
      description: 'Un client veut déposer un colis chez vous. Répondez avant la fin du délai.',
      from: 'Client',
      destination: 'Livraison à',
      hold: 'Le destinataire viendra le retirer ici',
      size: 'Taille',
      answerTime: 'Délai pour répondre',
      slide: 'Glissez pour accepter',
      later: 'Plus tard',
      more: '{count} autre demande en attente | {count} autres demandes en attente',
      accepted: 'Demande acceptée',
      failed: 'Cette demande n’est plus disponible.',
      toast: 'Nouvelle demande de dépôt',
      view: 'Voir'
    },
    agent: {
      request: 'Nouvelle demande de dépôt',
      answer: 'Répondre',
      arrival: 'Un livreur arrive avec {count} colis | Un livreur arrive avec {count} colis',
      receive: 'Recevoir',
      return: 'Un retour a été accepté : reprenez le colis et déposez-le',
      deposit: 'Déposer'
    },
    courier: {
      return: 'Un colis retourné attend un livreur',
      returnView: 'Voir'
    },
    next: {
      answer: '{count} demande à traiter | {count} demandes à traiter',
      answerHint: 'Un client attend votre réponse',
      receive: '{count} livreur à recevoir | {count} livreurs à recevoir',
      receiveHint: 'Recevez les colis déposés au relais',
      deliver: '{count} colis à remettre | {count} colis à remettre',
      deliverHint: 'Ils sont au relais, prêts pour le destinataire',
      handover: '{count} colis à gérer au relais | {count} colis à gérer au relais',
      handoverHint: 'Expéditeurs et livreurs attendus',
      deposit: '{count} retour à déposer | {count} retours à déposer',
      depositHint: 'Reprenez le colis et déposez-le avec photos'
    },
    customer: {
      view: 'Voir',
      parcel: {
        ready_to_collect: 'Votre colis attend le destinataire au point relais',
        collected: 'Le destinataire a retiré votre colis',
        dropped_off: 'Votre colis est déposé et prêt à partir',
        on_the_way: 'Votre colis est en route',
        delivered: 'Votre colis a été livré',
        problem: 'Il y a un problème avec votre colis, nous nous en occupons',
        cancelled: 'Votre envoi a été annulé',
        returned: 'Votre colis vous a été rendu',
        requested: 'Votre colis est en préparation',
        returning: 'Votre colis est en chemin de retour vers vous',
        return_ready: 'Votre colis est revenu : venez le récupérer'
      },
      return: {
        accepted: 'Votre demande de retour a été acceptée',
        rejected: 'Votre demande de retour a été refusée',
        declined: 'Votre demande de retour a été refusée'
      },
      request: {
        accepted: 'Votre demande a été acceptée',
        declined: 'Votre demande a été refusée',
        rejected: 'Votre demande n’a pas été retenue'
      },
      active: 'Votre colis en cours',
      activeHint: 'Touchez pour suivre',
      share: 'Partager le suivi',
      shareTitle: 'Suivi de colis',
      shareText: 'Suivez mon colis {code} :'
    },
    sound: {
      on: 'Alertes avec son et vibration',
      off: 'Alertes en silence'
    },
    countdown: {
      left: '{time} restant',
      hm: '{h} h {m} min',
      m: '{m} min',
      expired: 'Délai dépassé'
    },
    log: {
      title: 'Vos alertes',
      empty: 'Rien de nouveau pour le moment.'
    },
    today: {
      title: 'Gagné aujourd’hui',
      parcels: '{count} colis livré | {count} colis livrés',
      none: 'Pas encore de colis'
    },
    wait: {
      title: '{count} colis attend depuis plus d’un jour | {count} colis attendent depuis plus d’un jour',
      oldest: 'Le plus ancien : {time}',
      hours: '{value} heure | {value} heures',
      days: '{value} jour | {value} jours'
    },
    delivered: {
      title: 'Votre colis est livré',
      hint: 'Le destinataire l’a bien reçu.',
      ok: 'Tout est bon, merci',
      report: 'Signaler un problème ou demander un retour'
    },
    again: {
      title: 'Renvoyer à {name}',
      note: 'Les informations de votre dernière demande ont été reprises. Vérifiez-les avant d’envoyer.'
    },
    status: {
      live: 'En direct',
      reconnecting: 'Reconnexion…'
    }
  },
  en: {
    offer: {
      title: 'New collection',
      description: 'First come, first served.',
      from: 'Collect from',
      parcels: '{count} parcel | {count} parcels',
      cash: 'Cash to collect',
      accept: 'Accept',
      slide: 'Slide to accept',
      later: 'Not now',
      more: '{count} more waiting | {count} more waiting',
      taken: 'Another courier just took this collection.',
      accepted: 'Collection accepted',
      toast: 'New collection available',
      returnTitle: 'Return to collect',
      returnTo: 'Bring it to',
      returnAccepted: 'Return accepted',
      code: 'Parcel code',
      view: 'View'
    },
    job: {
      drop: 'Drop at {relay}',
      dropHint: '{count} parcel on you | {count} parcels on you',
      dropMany: '{count} parcel, {relays} relays | {count} parcels, {relays} relays',
      collect: 'Collect from {point}',
      dropNearest: 'Nearest of {relays} relays · {km} km | Nearest of {relays} relays · {km} km',
      nearestFirst: 'Nearest first',
      collectAnon: 'Collect your accepted collection',
      collectHint: '{count} parcel to pick up | {count} parcels to pick up',
      accept: '{count} collection to take | {count} collections to take',
      acceptHint: 'First come, first served',
      navigate: 'Directions',
      call: 'Call'
    },
    arrivalOffer: {
      title: 'A courier is here',
      description: 'A courier has just dropped parcels with you. Receive them now.',
      from: 'Courier',
      slide: 'Slide to receive',
      later: 'Not now',
      more: '{count} more courier waiting | {count} more couriers waiting'
    },
    returnReady: {
      title: 'Your parcel is back',
      hint: 'Collect it at the relay with this code.',
      open: 'Open my parcel',
      later: 'Not now',
      relay: 'Relay'
    },
    returnOffer: {
      badge: 'Return',
      depositTitle: 'Return accepted',
      depositDescription: 'Take the parcel back, then deposit it so a courier can bring it home.',
      depositHeadline: 'Take the parcel back and deposit it',
      arriveTitle: 'The courier is here',
      arriveDescription: 'A courier is bringing you a returned parcel. Receive it, then hand it to its sender.',
      arriveHeadline: 'A parcel is coming back to you',
      sender: 'Sender',
      recipient: 'Recipient',
      depositSlide: 'Slide to take it back',
      arriveSlide: 'Slide to receive it',
      received: 'Parcel received',
      handbackTitle: 'Cancellation accepted',
      handbackDescription: 'The customer is coming to collect their parcel. Keep it at the counter and ask for their code.',
      handbackHeadline: 'Keep the parcel for the customer',
      handbackSlide: 'Slide to open the parcel',
      later: 'Not now',
      more: '{count} more return waiting | {count} more returns waiting'
    },
    requestOffer: {
      title: 'New drop-off request',
      description: 'A customer wants to drop a parcel with you. Answer before the time runs out.',
      from: 'Customer',
      destination: 'Delivery to',
      hold: 'The recipient will collect it here',
      size: 'Size',
      answerTime: 'Time to answer',
      slide: 'Slide to accept',
      later: 'Not now',
      more: '{count} more request waiting | {count} more requests waiting',
      accepted: 'Request accepted',
      failed: 'This request is no longer available.',
      toast: 'New drop-off request',
      view: 'View'
    },
    agent: {
      request: 'New drop-off request',
      answer: 'Answer',
      arrival: 'A courier is arriving with {count} parcel | A courier is arriving with {count} parcels',
      receive: 'Receive',
      return: 'A return was accepted: take the parcel back and deposit it',
      deposit: 'Deposit'
    },
    courier: {
      return: 'A returned parcel is waiting for a courier',
      returnView: 'View'
    },
    next: {
      answer: '{count} request to answer | {count} requests to answer',
      answerHint: 'A customer is waiting for your reply',
      receive: '{count} courier to receive | {count} couriers to receive',
      receiveHint: 'Receive the parcels dropped at your relay',
      deliver: '{count} parcel to hand over | {count} parcels to hand over',
      deliverHint: 'At your relay, ready for the recipient',
      handover: '{count} parcel to handle at the relay | {count} parcels to handle at the relay',
      handoverHint: 'Senders and couriers expected',
      deposit: '{count} return to deposit | {count} returns to deposit',
      depositHint: 'Take the parcel back and deposit it with photos'
    },
    customer: {
      view: 'View',
      parcel: {
        ready_to_collect: 'Your parcel is waiting for the recipient at the relay',
        collected: 'The recipient collected your parcel',
        dropped_off: 'Your parcel is dropped off and ready to go',
        on_the_way: 'Your parcel is on the way',
        delivered: 'Your parcel was delivered',
        problem: 'There is a problem with your parcel, we are on it',
        cancelled: 'Your shipment was cancelled',
        returned: 'Your parcel was given back to you',
        requested: 'Your parcel is being prepared',
        returning: 'Your parcel is on its way back to you',
        return_ready: 'Your parcel is back: come and collect it'
      },
      return: {
        accepted: 'Your return request was accepted',
        rejected: 'Your return request was refused',
        declined: 'Your return request was refused'
      },
      request: {
        accepted: 'Your request was accepted',
        declined: 'Your request was declined',
        rejected: 'Your request was not accepted'
      },
      active: 'Your parcel in progress',
      activeHint: 'Tap to follow it',
      share: 'Share tracking',
      shareTitle: 'Parcel tracking',
      shareText: 'Follow my parcel {code}:'
    },
    sound: {
      on: 'Alerts with sound and vibration',
      off: 'Alerts silenced'
    },
    countdown: {
      left: '{time} left',
      hm: '{h} h {m} min',
      m: '{m} min',
      expired: 'Time is up'
    },
    log: {
      title: 'Your alerts',
      empty: 'Nothing new right now.'
    },
    today: {
      title: 'Earned today',
      parcels: '{count} parcel delivered | {count} parcels delivered',
      none: 'No parcels yet'
    },
    wait: {
      title: '{count} parcel has waited over a day | {count} parcels have waited over a day',
      oldest: 'Oldest: {time}',
      hours: '{value} hour | {value} hours',
      days: '{value} day | {value} days'
    },
    delivered: {
      title: 'Your parcel was delivered',
      hint: 'The recipient has it.',
      ok: 'All good, thanks',
      report: 'Report a problem or request a return'
    },
    again: {
      title: 'Send again to {name}',
      note: 'The details from your last request were copied. Check them before you send.'
    },
    status: {
      live: 'Live',
      reconnecting: 'Reconnecting…'
    }
  },
  ar: {
    offer: {
      title: 'عملية جمع جديدة',
      description: 'الأسبق هو الأحق.',
      from: 'الجمع من',
      parcels: '{count} طرود',
      cash: 'المبلغ النقدي المطلوب',
      accept: 'قبول',
      slide: 'اسحب للقبول',
      later: 'لاحقاً',
      more: '{count} أخرى في الانتظار',
      taken: 'أخذ موزّع آخر هذه العملية للتو.',
      accepted: 'تم قبول عملية الجمع',
      toast: 'عملية جمع جديدة متاحة',
      returnTitle: 'إرجاع للاستلام',
      returnTo: 'يُعاد إلى',
      returnAccepted: 'تم قبول الإرجاع',
      code: 'رمز الطرد',
      view: 'عرض'
    },
    job: {
      drop: 'التسليم في {relay}',
      dropHint: '{count} طرود معك',
      dropMany: '{count} طرود، {relays} نقاط',
      collect: 'الجمع من {point}',
      dropNearest: 'الأقرب من بين {relays} نقاط · {km} كم',
      nearestFirst: 'الأقرب أولاً',
      collectAnon: 'اجمع العملية التي قبلتها',
      collectHint: '{count} طرود للاستلام',
      accept: '{count} عمليات جمع متاحة',
      acceptHint: 'الأسبق هو الأحق',
      navigate: 'الاتجاهات',
      call: 'اتصال'
    },
    arrivalOffer: {
      title: 'وصل موزّع',
      description: 'وصل موزّع للتو ومعه طرود. استلمها معه.',
      from: 'الموزّع',
      slide: 'اسحب للاستلام',
      later: 'ليس الآن',
      more: 'موزّع آخر في الانتظار | {count} موزّعين آخرين في الانتظار'
    },
    returnReady: {
      title: 'عاد طردك',
      hint: 'استلمه من النقطة بهذا الرمز.',
      open: 'فتح طردي',
      later: 'ليس الآن',
      relay: 'النقطة'
    },
    returnOffer: {
      badge: 'إرجاع',
      depositTitle: 'تم قبول الإرجاع',
      depositDescription: 'استرجع الطرد ثم أودعه ليعيده موزّع.',
      depositHeadline: 'استرجع الطرد وأودعه',
      arriveTitle: 'وصل الموزّع',
      arriveDescription: 'موزّع يعيد إليك طرداً مُعاداً. استلمه ثم سلّمه لمرسله.',
      arriveHeadline: 'طرد يعود إليك',
      sender: 'المرسل',
      recipient: 'المستلم',
      depositSlide: 'اسحب لاسترجاعه',
      arriveSlide: 'اسحب لاستلامه',
      received: 'تم استلام الطرد',
      handbackTitle: 'تم قبول الإلغاء',
      handbackDescription: 'الزبون قادم لاستلام طرده. احتفظ به عندك واطلب منه رمزه.',
      handbackHeadline: 'احتفظ بالطرد للزبون',
      handbackSlide: 'اسحب لفتح الطرد',
      later: 'ليس الآن',
      more: 'إرجاع آخر في الانتظار | {count} إرجاعات أخرى في الانتظار'
    },
    requestOffer: {
      title: 'طلب إيداع جديد',
      description: 'الزبون يريد إيداع طرد عندك. أجب قبل انتهاء المهلة.',
      from: 'الزبون',
      destination: 'التوصيل إلى',
      hold: 'سيأتي المستلم لأخذه من هنا',
      size: 'الحجم',
      answerTime: 'مهلة الرد',
      slide: 'اسحب للقبول',
      later: 'ليس الآن',
      more: 'طلب آخر في الانتظار | {count} طلبات أخرى في الانتظار',
      accepted: 'تم قبول الطلب',
      failed: 'هذا الطلب لم يعد متاحًا.',
      toast: 'طلب إيداع جديد',
      view: 'عرض'
    },
    agent: {
      request: 'طلب إيداع جديد',
      answer: 'رد',
      arrival: 'موزّع قادم ومعه {count} طرود',
      receive: 'استلام',
      return: 'تم قبول إرجاع: استرجع الطرد وأودعه',
      deposit: 'إيداع'
    },
    courier: {
      return: 'طرد مُعاد ينتظر موزّعاً',
      returnView: 'عرض'
    },
    next: {
      answer: '{count} طلبات تنتظر ردك',
      answerHint: 'زبون ينتظر جوابك',
      receive: '{count} موزّعين لاستقبالهم',
      receiveHint: 'استلم الطرود الواصلة إلى نقطتك',
      deliver: '{count} طرود للتسليم',
      deliverHint: 'في نقطتك وجاهزة للمستلم',
      handover: '{count} طرود للتعامل معها في النقطة',
      handoverHint: 'مرسلون وموزّعون متوقعون',
      deposit: '{count} إرجاعات للإيداع',
      depositHint: 'استرجع الطرد وأودعه مع الصور'
    },
    customer: {
      view: 'عرض',
      parcel: {
        ready_to_collect: 'طردك ينتظر المستلم في نقطة التسليم',
        collected: 'استلم المستلم طردك',
        dropped_off: 'تم إيداع طردك وهو جاهز للانطلاق',
        on_the_way: 'طردك في الطريق',
        delivered: 'تم تسليم طردك',
        problem: 'هناك مشكلة في طردك ونحن نتولى الأمر',
        cancelled: 'تم إلغاء الشحنة',
        returned: 'تمت إعادة الطرد إليك',
        requested: 'طردك قيد التحضير',
        returning: 'طردك في طريق العودة إليك',
        return_ready: 'عاد طردك: تعال لاستلامه'
      },
      return: {
        accepted: 'تم قبول طلب الإرجاع',
        rejected: 'تم رفض طلب الإرجاع',
        declined: 'تم رفض طلب الإرجاع'
      },
      request: {
        accepted: 'تم قبول طلبك',
        declined: 'تم رفض طلبك',
        rejected: 'لم يتم قبول طلبك'
      },
      active: 'طردك الجاري',
      activeHint: 'اضغط للمتابعة',
      share: 'مشاركة التتبع',
      shareTitle: 'تتبع الطرد',
      shareText: 'تابع طردي {code}:'
    },
    sound: {
      on: 'التنبيهات بالصوت والاهتزاز',
      off: 'التنبيهات صامتة'
    },
    countdown: {
      left: 'متبقي {time}',
      hm: '{h} س {m} د',
      m: '{m} د',
      expired: 'انتهت المهلة'
    },
    log: {
      title: 'تنبيهاتك',
      empty: 'لا جديد حالياً.'
    },
    today: {
      title: 'ربحت اليوم',
      parcels: '{count} طرود مسلّمة',
      none: 'لا طرود بعد'
    },
    wait: {
      title: '{count} طرود تنتظر منذ أكثر من يوم',
      oldest: 'الأقدم: {time}',
      hours: '{value} ساعة',
      days: '{value} أيام'
    },
    delivered: {
      title: 'تم تسليم طردك',
      hint: 'استلمه المستلم.',
      ok: 'كل شيء على ما يرام، شكراً',
      report: 'الإبلاغ عن مشكلة أو طلب إرجاع'
    },
    again: {
      title: 'أرسل مجدداً إلى {name}',
      note: 'تم نسخ بيانات طلبك الأخير. راجعها قبل الإرسال.'
    },
    status: {
      live: 'مباشر',
      reconnecting: 'جارٍ إعادة الاتصال…'
    }
  },
  ma: {
    offer: {
      title: 'كوليكت جديد',
      description: 'اللي سبق ياخد.',
      from: 'جمّع من عند',
      parcels: '{count} كولي',
      cash: 'الفلوس اللي خاصك تقبض',
      accept: 'قبل',
      slide: 'جرّ باش تقبل',
      later: 'موراها',
      more: '{count} آخرين كيتسناو',
      taken: 'واحد الليفرور آخر قبل هاد الكوليكت دابا.',
      accepted: 'قبلتي الكوليكت',
      toast: 'كاين كوليكت جديد',
      returnTitle: 'إرجاع خاصك تجمع',
      returnTo: 'سير بيه ل',
      returnAccepted: 'قبلتي الإرجاع',
      code: 'الكود د الكولي',
      view: 'شوف'
    },
    job: {
      drop: 'سلّم فـ {relay}',
      dropHint: '{count} كولي معاك',
      dropMany: '{count} كولي، {relays} نقط',
      collect: 'جمّع من عند {point}',
      dropNearest: 'الأقرب من بين {relays} نقط · {km} كم',
      nearestFirst: 'الأقرب لولا',
      collectAnon: 'جمّع الكوليكت اللي قبلتي',
      collectHint: '{count} كولي خاصك تاخد',
      accept: '{count} كوليكت كيتسناو',
      acceptHint: 'اللي سبق ياخد',
      navigate: 'الطريق',
      call: 'عيّط'
    },
    arrivalOffer: {
      title: 'ليفرور وصل',
      description: 'ليفرور وصل دابا ومعاه كولي. استقبلهم معاه.',
      from: 'ليفرور',
      slide: 'جرّ باش تستقبل',
      later: 'موراها',
      more: 'ليفرور آخر كيتسنى | {count} ليفرورات آخرين كيتسناو'
    },
    returnReady: {
      title: 'الكولي ديالك رجع',
      hint: 'دّيه من النقطة بهاد الكود.',
      open: 'حل الكولي ديالي',
      later: 'موراها',
      relay: 'النقطة'
    },
    returnOffer: {
      badge: 'رجوع',
      depositTitle: 'تقبل الرجوع',
      depositDescription: 'رجّع الكولي وخلّيه باش ليفرور يرجعو.',
      depositHeadline: 'رجّع الكولي وخلّيه',
      arriveTitle: 'الليفرور وصل',
      arriveDescription: 'ليفرور جاب ليك كولي مرجّع. استقبلو وسلّمو للمرسل.',
      arriveHeadline: 'كولي راجع ليك',
      sender: 'المرسل',
      recipient: 'المستلم',
      depositSlide: 'جرّ باش ترجعو',
      arriveSlide: 'جرّ باش تستقبلو',
      received: 'الكولي تستقبل',
      handbackTitle: 'الإلغاء تقبل',
      handbackDescription: 'الكليان جاي ياخد الكولي ديالو. خليه عندك وسوّلو على الكود ديالو.',
      handbackHeadline: 'خلّي الكولي للكليان',
      handbackSlide: 'جرّ باش تحل الكولي',
      later: 'موراها',
      more: 'رجوع آخر كيتسنى | {count} رجوعات أخرى كيتسناو'
    },
    requestOffer: {
      title: 'طلب إيداع جديد',
      description: 'الزبون بغا يخلي عندك كولي. جاوب قبل ما تسالي المهلة.',
      from: 'الزبون',
      destination: 'التوصيل ل',
      hold: 'المستلم غادي يجي ياخدو من هنا',
      size: 'الحجم',
      answerTime: 'المهلة باش تجاوب',
      slide: 'جرّ باش تقبل',
      later: 'موراها',
      more: 'طلب آخر كيتسنى | {count} طلبات أخرى كيتسناو',
      accepted: 'تقبل الطلب',
      failed: 'هاد الطلب ما بقاش متاح.',
      toast: 'طلب إيداع جديد',
      view: 'شوف'
    },
    agent: {
      request: 'طلب جديد باش يخلّي كولي',
      answer: 'جاوب',
      arrival: 'ليفرور جاي ومعاه {count} كولي',
      receive: 'استقبل',
      return: 'تقبل إرجاع: رجّع الكولي وخلّيه عندك',
      deposit: 'خلّي'
    },
    courier: {
      return: 'كاين كولي مرجّع كيتسنى ليفرور',
      returnView: 'شوف'
    },
    next: {
      answer: '{count} طلبات كيتسناو جوابك',
      answerHint: 'كاين زبون كيتسنى الجواب ديالك',
      receive: '{count} ليفرورات خاصك تستقبل',
      receiveHint: 'استقبل الكوليات اللي وصلو للنقطة ديالك',
      deliver: '{count} كولي خاصك تسلّم',
      deliverHint: 'عندك فالنقطة وجاهزين للمستلم',
      handover: '{count} كولي خاصك تتعامل معاهم',
      handoverHint: 'كاينين مرسلين وليفرورات متسناين',
      deposit: '{count} إرجاعات خاصك تخلّي',
      depositHint: 'رجّع الكولي وخلّيه مع التصاور'
    },
    customer: {
      view: 'شوف',
      parcel: {
        ready_to_collect: 'الكولي ديالك كيتسنى المستلم فنقطة التسليم',
        collected: 'المستلم تسلم الكولي ديالك',
        dropped_off: 'الكولي ديالك تخلّى وجاهز يمشي',
        on_the_way: 'الكولي ديالك فالطريق',
        delivered: 'الكولي ديالك وصل',
        problem: 'كاين مشكل فالكولي ديالك وحنا كنتكلفو بيه',
        cancelled: 'الإرسال تلغى',
        returned: 'الكولي رجع ليك',
        requested: 'الكولي ديالك كيتحضّر',
        returning: 'الكولي ديالك راجع ليك فالطريق',
        return_ready: 'الكولي ديالك رجع: جي دّيه'
      },
      return: {
        accepted: 'طلب الإرجاع ديالك تقبل',
        rejected: 'طلب الإرجاع ديالك تّرفض',
        declined: 'طلب الإرجاع ديالك تّرفض'
      },
      request: {
        accepted: 'الطلب ديالك تقبل',
        declined: 'الطلب ديالك تّرفض',
        rejected: 'الطلب ديالك ما تقبلش'
      },
      active: 'الكولي ديالك اللي فالطريق',
      activeHint: 'ضغط باش تتبع',
      share: 'شارك التتبع',
      shareTitle: 'تتبع الكولي',
      shareText: 'تبع الكولي ديالي {code}:'
    },
    sound: {
      on: 'التنبيهات بالصوت والاهتزاز',
      off: 'التنبيهات بلا صوت'
    },
    countdown: {
      left: 'بقا {time}',
      hm: '{h} س {m} د',
      m: '{m} د',
      expired: 'سالات المهلة'
    },
    log: {
      title: 'التنبيهات ديالك',
      empty: 'ما كاين والو جديد دابا.'
    },
    today: {
      title: 'اللي ربحتي اليوم',
      parcels: '{count} كولي تسلّم',
      none: 'باقي ما كاين حتى كولي'
    },
    wait: {
      title: '{count} كولي كيتسناو من أكتر من نهار',
      oldest: 'الأقدم: {time}',
      hours: '{value} ساعة',
      days: '{value} أيام'
    },
    delivered: {
      title: 'الكولي ديالك وصل',
      hint: 'المستلم تسلّمو.',
      ok: 'كلشي مزيان، شكرا',
      report: 'بلّغ على مشكل ولا طلب إرجاع'
    },
    again: {
      title: 'صيفط مرة أخرى ل {name}',
      note: 'تنسخو المعلومات د الطلب الأخير ديالك. شوفهم مزيان قبل ما تصيفط.'
    },
    status: {
      live: 'مباشر',
      reconnecting: 'كنعاودو نتّاصلو…'
    }
  }
}
